import React from 'react';
import '../styles/policy.css'; // Use this CSS file to maintain consistent styling

const PrivacyPolicy = () => {
  return (
    <div className="policy-container">
      <h1>Πολιτική Απορρήτου</h1>

      <h2>Συλλογή και Χρήση Δεδομένων</h2>
      <p>
        Στην ιστοσελίδα μας συλλέγουμε προσωπικά δεδομένα με στόχο τη βελτίωση των υπηρεσιών μας και της εμπειρίας των χρηστών. 
        Τα δεδομένα αυτά μπορεί να περιλαμβάνουν το όνομα, το email, και στοιχεία επικοινωνίας που συμπληρώνετε στις φόρμες επικοινωνίας.
      </p>

      <h2>Πώς χρησιμοποιούμε τα δεδομένα σας;</h2>
      <p>
        Τα προσωπικά σας δεδομένα χρησιμοποιούνται για τους εξής σκοπούς:
      </p>
      <ul>
        <li>Για να επικοινωνήσουμε μαζί σας σχετικά με τις υπηρεσίες μας.</li>
        <li>Για τη βελτίωση της ιστοσελίδας και των υπηρεσιών μας.</li>
        <li>Για να σας στέλνουμε ενημερωτικά δελτία εφόσον έχετε εγγραφεί.</li>
      </ul>

      <h2>Ασφάλεια των Δεδομένων</h2>
      <p>
        Η ασφάλεια των προσωπικών σας δεδομένων είναι προτεραιότητά μας. Έχουμε λάβει μέτρα για την προστασία τους από μη εξουσιοδοτημένη πρόσβαση ή κακόβουλη χρήση.
      </p>

      <h2>Δικαιώματα των Χρηστών</h2>
      <p>
        Έχετε το δικαίωμα να ζητήσετε πρόσβαση στα προσωπικά σας δεδομένα, καθώς και τη διόρθωση, διαγραφή ή περιορισμό της επεξεργασίας τους. Για να υποβάλετε σχετικό αίτημα, επικοινωνήστε μαζί μας μέσω email.
      </p>

      <h2>Cookies και Παρόμοιες Τεχνολογίες</h2>
      <p>
        Χρησιμοποιούμε cookies για τη συλλογή πληροφοριών που συμβάλλουν στη βελτίωση της εμπειρίας χρήστη. Για λεπτομέρειες σχετικά με τη χρήση των cookies, ανατρέξτε στην <a href="/cookies-policy">Πολιτική Cookies</a>.
      </p>

      <h2>Επικοινωνία</h2>
      <p>
        Για ερωτήσεις σχετικά με την Πολιτική Απορρήτου ή τη διαχείριση των δεδομένων σας, επικοινωνήστε μαζί μας στο <a href="mailto: sofiadavh@gmail.com">sofiadavh@gmail.com</a>.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
